import { InputEdit } from "components";
import { useEffect, useState } from "react";
import { Button, Col, Container, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "utils/hooks";
import "./Login.css";

import { COLORS } from "utils/colors";

export function Login() {
  const {
    onLogin,
    isUserAuthenticated,
    isUserAuthorized,
  } = useAuth();

  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setError] = useState("");

  useEffect(() => {
    async function verifyAuth() {
      
      if (isUserAuthenticated && isUserAuthorized) {
        navigate("/overview/dashboard");
        return;
      }

      if (isUserAuthenticated) {
        navigate("/select-tenant");
        return;
      }
    }

    verifyAuth();
  }, [isUserAuthenticated, isUserAuthorized]);

  return (
    <div className="classy-subtle-dark-gray-gradient">
      <Container>
        <Container className="d-flex align-items-center justify-content-center vh-100 login-container login-component-grow">
          <Col md={4}>
            <Form className="shadow  login-form" style={{ opacity: 0.9 }}>
              <Form.Group className="text-center">
                <img
                  src="/logo/logo.png"
                  width={200}
                  className="rounded img-responsive"
                  alt="ECHO Platform"
                />
              </Form.Group>
              <Form.Group style={{ opacity: 1 }}>
                <InputEdit
                  placeholder={"Username or Email"}
                  error={errorMessage}
                  
                  onFocus={(e) => {
                    setError(null);
                  }}
                  onChange={(e) => {
                    setError(null);
                    setUsername(e.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group style={{ opacity: 1 }}>
                <InputEdit
                  type={"password"}
                  placeholder={"Password"}
                  error={errorMessage}
                  
                  onFocus={(e) => {
                    setError(null);
                  }}
                  onChange={(e) => {
                    setError(null);
                    setPassword(e.target.value);
                  }}
                />
              </Form.Group>
              {errorMessage && (
                <Form.Group className="mb-0 mt-1" style={{ opacity: 1 }}>
                  <p style={{color:"red"}} className="m-0 p-0">{errorMessage}</p>
                </Form.Group>
              )}
              <Form.Group style={{ opacity: 1,  textAlign: "end"  }}>
                <a
                  href="/forgotpassword" // change this to your route
                  style={{ color: COLORS.greyFontColor }}
                  className="m-0 pt-2 hover-underline-grow hover-italic"
                >
                  <b>Forgot Password?</b>
                </a>
              </Form.Group>

              <Form.Group className="text-center">
                <Button
                  type="submit"
                  // lg={8}
                  className="btn btn-primary mt-3 w-100"
                  onClick={async (e) => {
                    e.preventDefault();

                    const result = await onLogin(username, password);
                    if (!result) {
                      setError("Email or password are wrong");
                      return;
                    }
                  }}
                >
                  Login
                </Button>
              </Form.Group>
            </Form>
          </Col>
        </Container>
      </Container>
    </div>
  );
}
